<template>
    <div class="section-box">

        <div class="customer-list">
            <el-row class="customer-row-bg">
                <el-col :span="20" style="text-align: left; display: flex; align-items: center">
                    <el-form :inline="true" label-width="90px" label-position="left">
                        <el-form-item label="工单Id">
                            <el-input v-model="form.JobId" placeholder="输入工单Id"></el-input>
                        </el-form-item>
                        <el-form-item label="负责人">
                            <el-select v-model="form.AdminUserId" placeholder="选择接收人">
                                <el-option label="请选择负责人" :value="0"></el-option>
                                <el-option v-for="(item, index) in djrArr" :label="item.RealName" :value="item.UserId"
                                    :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="4">
                    <el-form inline label-width="90px" label-position="left" style="text-align: right">
                        <el-form-item>
                            <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>


        <!-- 列表 -->
        <el-table :stripe="true" :data="tableData" style="width: 100%" height="500" border v-loading="listLoading"
            :header-cell-style="{ background: '#F5F7FA' }">
            <!-- eslint-disable  -->
            <el-table-column label="场景" width="300">
                <template slot-scope="scope">
                    <span>{{ scope.row.MsgTitle || "--" }}</span>
                </template>
            </el-table-column>

            <el-table-column label="消息内容">
                <template slot-scope="scope">
                    <span>{{ (scope.row.MsgType == 1 ? scope.row.HandMsg : scope.row.ComWxMsg) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="消息类别" width="100">
                <template slot-scope="scope">
                    <span>{{ scope.row.MsgTypeName || "--" }}</span>
                </template>
            </el-table-column>
            <el-table-column label="发送时间" width="180">
                <template slot-scope="scope">
                    <span>{{ scope.row.CreateDateStr || "--" }}</span>
                </template>
            </el-table-column>
            <el-table-column label="接收人员" width="180">
                <template slot-scope="scope">
                    <span>{{ scope.row.ManageUserName || scope.row.HandSet || '--' }}</span>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px; overflow: hidden" v-show="tableData.length">
            <div style="float: right">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="form.PageNo" :page-sizes="[10, 20, 50, 100, 200]" :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getMessageList
} from "@/service/message";
import {
    getTakeOverUserList
} from "@/service/job";
export default {
    data() {
        return {
            listLoading: false,
            form: {
                PageNo: 1,
                PageSize: 10,
                JobId: "",
                AdminUserId: 0,
            },
            oraginForm: {},

            total: 0, //总条数
            tableData: [],
            djrArr: []
        };
    },
    activated() {
        this.handleSearch();
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form));
        this.tableData = [];
        this.getTakeOverUserListFun();
    },
    watch: {
        "form.JobId": function (val) {
            console.log("form.JobId changed to:", val);
        }
    },
    methods: {
        // 获取对接人
        getTakeOverUserListFun() {
            getTakeOverUserList().then(res => {
                this.djrArr = res.Data;
            })
        },
        //渲染列表
        handleSearch() {
            this.handleCurrentChange(1);
        },
        handleCurrentChange(val) {
            if (this.listLoading) return;
            this.form.PageNo = val;
            this.getMessageList();
        },
        //翻页
        handleSizeChange(val) {
            if (this.listLoading) return;
            this.form.PageNo = 1;
            this.form.PageSize = val;
            this.getMessageList();
        },
        // TODO：修改接口名 form参数 table展示数据 -> 平台、发单方角色select
        async getMessageList() {
            const _this = this


            var data = {
                JobId: 0,
                AdminUserId: 0,
                PageNum: this.form.PageNo,
                PageSize: this.form.PageSize,
            }
            console.log("getMessageList  this.form.AdminUserId", this.form.AdminUserId);

            if (this.form.JobId) {

                if (!/^\d+$/.test(this.form.JobId)) {
                    return this.$message.error("工单Id请输入数字");
                }

                data.JobId = this.form.JobId;
            }
            if (this.form.AdminUserId) data.AdminUserId = this.form.AdminUserId;
            this.listLoading = true;
            console.log("getMessageList data", data);
            let res = await getMessageList(data);
            this.listLoading = false;
            if (res.Result != 1) {
                return this.$message.error(res.Message);
            }

            this.tableData = res.Data.MsgList;
            this.total = res.Data.TotalCount;
        },
        handleReset() {
            this.form = Object.assign({}, this.oraginForm);
            this.handleSearch();
        },
    },
};
</script>

<style lang="scss">
.el-row {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
}

.row-bg {
    padding: 10px 14px;
    background-color: #f9fafc;
}

.startCls {
    width: 80px;
}
</style>